module.exports = __webpack_public_path__ + "static/media/Mobile_ilustration.dad9b8d5.svg";